export const enum RedactionMode {
  SHOW_NONE = 'SHOW_NONE',
  SHOW_ALL = 'SHOW_ALL',
  SHOW_SOME = 'SHOW_SOME',
}
